import { cn } from "@/lib/utils";
import { playersSelector } from "@/redux/players/playersSlice";
import { useSelector } from "react-redux";

export const playStyleIds = {
  scoring: [0, 1, 2, 3, 4, 42],
  passing: [5, 6, 7, 8, 9],
  defending: [10, 11, 12, 13, 14, 15],
  "ball-control": [16, 17, 18, 19, 20, 21],
  physical: [22, 23, 24, 25, 26, 27],
  goalkeeping: [28, 29, 30, 31, 32, 33],
};

export const PlayStyle = ({
  hasPlus,
  hasNormal,
  id,
  large = false,
}: {
  hasPlus: boolean;
  hasNormal: boolean;
  id: number;
  large?: boolean;
}) => {
  const { playStylesDict } = useSelector(playersSelector);
  const assetsBaseUrl = import.meta.env.VITE_APP_ASSETS_BASE_URL;
  const imageUrl = hasPlus
    ? `${assetsBaseUrl}/fc25/playstylesplus/${id}.png`
    : `${assetsBaseUrl}/fc25/playstyles/${id}.png`;
  return (
    <div className="flex flex-col items-center">
      <img
        key={id}
        src={imageUrl}
        alt={`PlayStyle ${id}`}
        className={cn(
          large ? "w-10 h-10" : "w-8 h-8",
          !hasNormal && !hasPlus ? "opacity-15" : "",
        )}
      />
      <div
        className={cn(
          "text-center truncate text-tiny -mt-1 bg-panel-background rounded-sm px-1",
          large ? "w-14 large-desktop:w-16 text-xs" : "w-12 text-[0.6rem]",
          !hasNormal && !hasPlus ? "text-dark-disabled" : "text-dark-secondary",
        )}
      >
        {playStylesDict[id]?.name}
      </div>
    </div>
  );
};
